import ButtonCol from 'components/form-elements/ButtonCol'
import ItemInput from 'components/form-elements/ItemInput'
import React, { useEffect, useState } from 'react'
import DetailDataTable from './DetailDataTable'
import { useFieldArray } from 'react-hook-form'
import Col from 'components/ui-elements/Col'
import useMsgBox from 'hooks/useMsgBox';
import { Row } from 'reactstrap'
import useAxiosFunction from 'hooks/useAxiosFunction'

const InputMultiple = (props) => {
    const [respax, errax, loadingax, fetchax] = useAxiosFunction();
    const [showMsg, confirmMsg] = useMsgBox();
    let { coltype, name = "detail", columns, addlabel = "Tambah Item", label, defaultValue,
        columnsdetail, title, control, register, setValue, handleSubmit, editid,
        watch, errors, iRenderFunc, defaultvalueurl, ...rest } = props

    const [mydef, setMydef] = useState(defaultValue)
    const { fields, append, remove } = useFieldArray({ control, name: name });

    const renderAction = (val, colname, item, coltype, idx) => {
        return <a href="#" onClick={() => { confirmDelete(idx) }} className="btn btn-danger btn-xs" title={"Hapus"}><i className={"fa fa-trash"} ></i></a>
    }

    const confirmDelete = async (idx) => {
        const res = await confirmMsg("Konfirmasi", "Apakah Anda yakin akan menghapus baris data ini?")
        if (res === true) {
            remove(idx)
        }
    }

    const cekDefaultColumns = () => {
        //Jika tidak ada coltype action, maka tambhakan
        //Jika sudah ada, cek ada tidaknya renderFunc, jika tidak ada maka tambahkan
        if (coltype?.iaction) {
            let actioncfg = coltype.iaction
            if (!actioncfg?.iRenderFunc) {
                //coltype.action = { ...coltype.action, renderFunc: renderAction }
                const actcfg = { ...actioncfg, iRenderFunc: renderAction }
                coltype = { ...coltype, iaction: actcfg }
            }
        } else {
            coltype = { ...coltype, iaction: { label: "Aksi", align: "center", iRenderFunc: renderAction } }
        }

        //Jika tidak ada coltype no, maka tambahkan
        if (!coltype?.no) {
            coltype = { ...coltype, no: { label: "No", width: 5, align: "center" } }
        }
    }
    cekDefaultColumns()
    const addRowBlank = () => {
        append({})
    }

    useEffect(() => {
        if (defaultvalueurl && defaultValue) {
            const myurl = defaultvalueurl ? defaultvalueurl + "/" + defaultValue?.[editid] : ""
            if (myurl) {
                fetchax({ method: "GET", url: myurl, auth: true })
            }
        }
    }, [])


    useEffect(() => {
        let myvals = mydef
        if (respax?.data && respax?.data.length > 0) {
            remove()
            respax?.data.map((item, idx) => {
                append(item)
                Object.keys(item).map((key) => {
                    myvals[name + "." + idx + "." + key] = item?.[key]
                })
            })
            //setMydef(myvals)
        }
    }, [respax])

    return (
        <>
            <Row>

                <Col size={8}>
                    {label && <label className='float-left'>{label}</label>}
                </Col>
                <Col>
                    <a href="#" onClick={addRowBlank} className="btn btn-default btn-xs float-right" title={addlabel}><i className={"fa fa-plus"} ></i> {addlabel}</a>

                </Col>
            </Row>
            <Row>
                <DetailDataTable
                    coltype={coltype}
                    data={fields}
                    columns={columnsdetail}
                    setValue={setValue}
                    register={register}
                    handleSubmit={handleSubmit}
                    watch={watch}
                    errors={errors}
                    control={control}
                    detailkey={name}
                    defaultValue={mydef}
                />
            </Row>
        </>
    )
}

export default InputMultiple
